import {graphql} from 'react-relay'

export const query = graphql`
  query PipelinesBreadcrumbsQuery(
    $pipelineLocator: String!
    $pipelineRunLocator: String!
    $fetchPipeline: Boolean!
    $fetchPipelineRun: Boolean!
  ) {
    pipeline(pipelineLocator: $pipelineLocator) @include(if: $fetchPipeline) {
      ...PipelinesBreadcrumbsPipelineFragment
    }
    build(buildLocator: $pipelineRunLocator) @include(if: $fetchPipelineRun) {
      ...PipelinesBreadcrumbsRunFragment
    }
  }
`
